import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { Database } from '../types/database.types';

// Use a more specific global reference to avoid conflicts
declare global {
  var __beauty_salon_supabase__: SupabaseClient<Database> | undefined;
}

const typedSupabase =
  globalThis.__beauty_salon_supabase__ ??
  createClient<Database>(
    import.meta.env.VITE_SUPABASE_URL!,
    import.meta.env.VITE_SUPABASE_ANON_KEY!,
    {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        storageKey: 'honey-auth',
        flowType: 'pkce',
        detectSessionInUrl: true,
      },
      global: {
        headers: {
          'X-Client-Info': 'beauty-salon-app',
        },
      },
    }
  );

// Store the instance globally
if (!globalThis.__beauty_salon_supabase__) {
  globalThis.__beauty_salon_supabase__ = typedSupabase;
}

export const supabase: SupabaseClient<any> = typedSupabase as unknown as SupabaseClient<any>;
export type TypedSupabaseClient = SupabaseClient<Database>;
export { typedSupabase };
